import axios from "axios";
import { useEffect, useState } from "react";
import { findEntityData } from "../api/apiService";
import tickIcon from "../assets/ok.webp";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [section1, setSection1] = useState()
  const findData = async () => {
    const res = await findEntityData('sss_contact_us')
    setSection1(res?.data?.[0]?.data)
  }

  useEffect(() => {
    findData()
  }, [])

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
    }
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      await axios({
        method: "POST",
        url: "https://script.google.com/macros/s/AKfycby2cIyiDo68z9zd3m2IcHxOsmQR6TbuqD7Xh4wuSKaEWecqbcEy0_96XShXvZB98-9R/exec",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        data: formData,
      });
      setShowModal(true);
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error sending message:", error);
      setShowModal(true);
    }
  };

  return (
    <div className="bg-[#F0F0E5] pt-12 min-h-screen overflow-x-hidden">
      <div className="text-center py-10">
        <h1 className="text-3xl md:text-4xl font-semibold text-[#F37934]" data-aos="zoom-in"
          data-aos-duration="800"
          data-aos-easing="ease-out">
          CONTACT US
        </h1>
      </div>
      {/* Address */}
      <div className="max-w-4xl mx-auto text-[#56453F] space-y-8 px-6">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Address */}
          <div className="bg-gradient-to-br from-[#F0F0E5] via-[#FFFFFF] to-[#F0F0E5] border border-white rounded-lg p-4 h-[140px] flex flex-col justify-center" data-aos="fade-right"
            data-aos-duration="1000">
            <h2 className="font-bold text-lg mb-2">ADDRESS:</h2>
            <p className="font-quicksand">
             {section1?.address}
            </p>
          </div>

          {/* Phone & Email */}
          <div className="flex flex-col gap-4 h-[140px]" data-aos="fade-left"
            data-aos-duration="1000">
            <div className="bg-gradient-to-br from-[#F0F0E500] via-[#FFFFFF] to-[#F0F0E500] border border-white rounded-lg p-4 flex items-center gap-4">
              <h2 className="font-bold text-lg">PHONE:</h2>
              <a
                className="font-quicksand"
                href="tel:+919884525802"
              >
                {section1?.phoneNumber}
              </a>

            </div>
            <div className="bg-gradient-to-br from-[#F0F0E500] via-[#FFFFFF] to-[#F0F0E500] border border-white rounded-lg p-4 flex items-center gap-4">
              <h2 className="font-bold text-lg">EMAIL:</h2>
              <a
                className="font-quicksand"
                href="mailto:connect@successshipping.in"
                target="_blank"
                rel="noopener noreferrer"
              >
               {section1?.email}
              </a>


            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-xl overflow-hidden h-[350px] w-full" data-aos="fade-right"
            data-aos-duration="1000">
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.0117432989664!2d80.29090727462476!3d13.098442187228692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526f520fffffff%3A0xb0ce9ff7b1b00770!2sSuccess%20Shipping%20Services!5e0!3m2!1sen!2sin!4v1757341113033!5m2!1sen!2sin"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full border-4 border-white rounded-2xl p-2"
            ></iframe>
          </div>
          <div className="font-quicksand text-[#615E5B] w-full" data-aos="fade-left"
            data-aos-duration="1000">
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  className={`w-full p-3 border rounded-lg focus:outline-none  ${errors.name ? "border-red-500" : ""
                    }`}
                />
                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                )}
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email address"
                  className={`w-full p-3 border rounded-lg focus:outline-none ${errors.email ? "border-red-500" : ""
                    }`}
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>

              <div>
                <textarea
                  rows="5"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Message"
                  className={`w-full p-3 border rounded-lg focus:outline-none ${errors.message ? "border-red-500" : ""
                    }`}
                ></textarea>
                {errors.message && (
                  <p className="text-red-500 text-sm mt-1">{errors.message}</p>
                )}
              </div>

              <button
                type="submit"
                className="w-full bg-[#F37934] hover:bg-[#F37934] text-white font-semibold py-3 rounded-lg transition duration-300"
              >
                Send Now
              </button>
            </form>

          </div>
        </div>
        {showModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-[#F0F0E5] rounded-2xl p-12 w-[500px] h-[320px] flex flex-col justify-center items-center text-center">
              <img src={tickIcon} alt="Success" className="w-16 h-16" />
              <h2 className="text-2xl font-bold">Thank you</h2>
              <p className=" mt-2 text-md font-semibold">
                Your message has been received.
              </p>
              <p className=" mt-2 text-md font-semibold">
                Our team will get back to you soon.
              </p>
              <button
                onClick={() => setShowModal(false)}
                className="mt-6 px-6 py-2 bg-[#F37934] text-white rounded-lg"
              >
                OK
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Contact;
